// Build identity for the footer. vite.config.ts injects the version from package.json and the commit from
// PREGO_COMMIT (CI passes CI_COMMIT_SHA), the same pattern as the registry's __PREGO_COMMIT__.
declare const __CONSOLE_VERSION__: string | undefined;
declare const __CONSOLE_COMMIT__: string | undefined;

export const VERSION: string = typeof __CONSOLE_VERSION__ === "string" ? __CONSOLE_VERSION__ : "0.0.0";
export const COMMIT: string = typeof __CONSOLE_COMMIT__ === "string" ? __CONSOLE_COMMIT__ : "";

/** The short commit: 7 hex characters, or "dev" for a local build with no commit. */
export function shortCommit(commit: string | undefined): string {
  const c = (commit ?? "").trim().toLowerCase();
  return /^[0-9a-f]{7,40}$/.test(c) ? c.slice(0, 7) : "dev";
}

/** The build slug in the footer, for example "console v0.2.0 · 2d0c1b3". */
export function buildSlug(version: string = VERSION, commit: string = COMMIT): string {
  return `console v${version} · ${shortCommit(commit)}`;
}

/** The copyright line in the footer. */
export const COPYRIGHT = "© 2026 Katskill LLC";
